export default __webpack_public_path__ + "static/media/odon.7af7c89d.png";